import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getRemoteConfig } from "firebase/remote-config";

const firebaseConfig = {
  apiKey: "AIzaSyBG6izgnV42fdhasrRw6k20ZKD4LrwfEVI",
  authDomain: "wheretogo-e5f51.firebaseapp.com",
  databaseURL: "https://wheretogo-e5f51.firebaseio.com",
  projectId: "wheretogo-e5f51",
  storageBucket: "wheretogo-e5f51.appspot.com",
  messagingSenderId: "386593767558",
  appId: "1:386593767558:web:1b53d21f7a52a15c0f1107",
  measurementId: "G-W0R9WC8F3L",
};

const app = initializeApp(firebaseConfig);

const storage = getStorage(app);

const auth = getAuth(app);

const defaultDb = getFirestore(app);

const firebaseRemoteConfig = getRemoteConfig(app);

firebaseRemoteConfig.settings.minimumFetchIntervalMillis = 3600000;

const providers = {
  google: new GoogleAuthProvider(),
};

export { app, storage, firebaseRemoteConfig, auth, providers, defaultDb };
